<template>
<el-affix :offset="0">
    <div id="header">
        <div class="box">
            <div class="leftLogo" @click="to('/')"><img src="../assets/logo_new.jpg" alt=""></div>
            <div class="tabUl">
                <el-menu
                    :default-active="activeIndex"
                    class="el-menu-demo"
                    mode="horizontal"
                    background-color="transparent"
                    text-color="#fff"
                    active-text-color="#FFFFFF"
                    @select="handleSelect"
                    :ellipsis = false
                >
                    <el-menu-item index="1" @click="to('/')">首页</el-menu-item>
                    <el-menu-item index="2" @click="to('/knowledge')">景区概况</el-menu-item>
                    <el-menu-item index="3" @click="to('tutorialCenter')">旅游攻略</el-menu-item>
                    <el-menu-item index="4" @click="to('deploy')">景点推荐</el-menu-item>
                    <el-menu-item index="5" @click="to('case')">游客服务</el-menu-item>
                    <el-menu-item index="6" @click="to('download')">资讯动态</el-menu-item>
                </el-menu>
            </div>
        </div>
    </div>
    </el-affix>
</template>

<script>
export default {
    data(){
        return{
            activeIndex:'1',
        }
    },
    mounted () {
        this.setActiveIndex();
    },
    methods:{
        handleSelect(key,keypath){
        },
        to(name){
            this.$router.push(name);
        },
        setActiveIndex(){
            const activeList = ['/','','/tutorialCenter','/deploy','/case']
            this.activeIndex = activeList.indexOf(this.$route.path) + 1;
        }
    },
    watch:{
        $route(){
            this.setActiveIndex();
        }
    },

}
</script>

<style scoped lang="scss">
#header{
    width: 100%;
    height: 80px;
    background: linear-gradient(90deg, #851C20 0%, #A6252C 100%);
    backdrop-filter: blur(10px);
    color: #FFFFFF;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
    transition: all 0.3s;
}
.box{
    height: 80px;
    margin:auto;
    max-width: 1280px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
}
.leftLogo{
    width:160px;
    height: 44px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: transform 0.3s;
    
    &:hover {
       transform: scale(1.05);
    }
}
.leftLogo img{
    height: 100%;
    width: auto;
}
.tabUl{
    height: 100%;
    display: flex;
    align-items: center;
    ::v-deep .el-menu--horizontal{
        border: none;
        height: 100%;
    }
    ::v-deep .el-menu--horizontal>.el-menu-item{
        padding: 0 24px;
        font-size: 16px;
        transition: all 0.3s;
        border-bottom: none;
        
        &:hover {
           background-color: rgba(255,255,255,0.15) !important;
           transform: translateY(-2px);
        }
    }
    ::v-deep .el-menu--horizontal>.el-menu-item.is-active{
        border:none;
        position: relative;
        background: rgba(255,255,255,0.2) !important;
        font-weight: 700;
        border-radius: 4px;
        
        &::before{
            content:'';
            width: 20px;
            height: 4px;
            background: #FFFFFF;
            position: absolute;
            bottom: 15px;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 2px;
        }
    }
    .searchImg{
        width: 20px;
        height: 20px;
        transition: transform 0.3s;
        
        &:hover {
           transform: scale(1.2);
        }
    }
}
</style>
<style lang="scss">
.el-popper{
    margin-top: -6px!important;
}
.el-menu--popup{
    background: rgba(30, 148, 147, 0.95)!important;
    min-width: 140px!important;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
    background-color: rgba(255,255,255,0.15)!important;
    color: #fff !important;
}
.el-popper.is-light{
    border: none!important;
}
.el-menu--horizontal{
    border: none!important;
}
.el-popper{
    border-radius: 4px!important;
}
</style>